import React from "react";
import PropTypes from "prop-types";
import CustomEvent from "custom-event";
import { BATCH_SCROLL, BATCH_SCROLL_UPDATE } from "./events";
import { getEventTarget } from "./BodyScroller";

export default class Renderer extends React.Component {
  static propTypes = {
    batchSize: PropTypes.number,
    total: PropTypes.number.isRequired,
    initialBatch: PropTypes.number,
    endBuffer: PropTypes.number,
    renderItem: PropTypes.func.isRequired,
    container: PropTypes.any
  };

  static defaultProps = {
    initialBatch: 50,
    batchSize: 10,
    endBuffer: 200,
    container: "div"
  };

  rootRef = React.createRef();

  state = {
    lastIndexToRender: Math.min(
      this.props.initialBatch - 1,
      this.props.total - 1
    ),
    visibleSize: 0,
    contentSize: 0,
    scrollLocation: 0
  };

  UNSAFE_componentWillReceiveProps(nextProps) {
    if (nextProps.total - 1 < this.state.lastIndexToRender) {
      this.setState({
        lastIndexToRender: nextProps.total - 1
      });
    } else if (this.props.total === 0 && nextProps.total > 0) {
      this.setState({
        lastIndexToRender: Math.min(
          nextProps.initialBatch - 1,
          nextProps.total - 1
        )
      });
    }
  }

  componentDidMount() {
    getEventTarget().addEventListener(BATCH_SCROLL, this.scrollEvent);
    this.rootRef.current.dispatchEvent(
      new CustomEvent(BATCH_SCROLL_UPDATE, { bubbles: true })
    );
  }

  componentWillUnmount() {
    getEventTarget().removeEventListener(BATCH_SCROLL, this.scrollEvent);
  }

  componentDidUpdate(prevProps, prevState) {
    // Don't trigger updates during initial size setting
    if (prevState.visibleSize === 0) {
      return;
    }

    const inEndZone =
      this.state.visibleSize +
        this.state.scrollLocation +
        this.props.endBuffer >=
      this.state.contentSize;
    const canScroll = this.state.contentSize > this.state.visibleSize;
    const itemsRenderedChanged =
      this.state.lastIndexToRender !== prevState.lastIndexToRender;

    if (itemsRenderedChanged) {
      this.sendUpdateEvent();
    }

    if (inEndZone || !canScroll) {
      this.tryShowAnotherBatch();
    }
  }

  sendUpdateEvent() {
    this.rootRef.current.dispatchEvent(
      new CustomEvent(BATCH_SCROLL_UPDATE, {
        bubbles: true
      })
    );
  }

  scrollEvent = e => {
    this.setState({
      scrollLocation: e.detail.scrollLocation,
      visibleSize: e.detail.visibleSize,
      contentSize: e.detail.contentSize
    });
  };

  tryShowAnotherBatch() {
    if (this.state.lastIndexToRender < this.props.total - 1) {
      this.setState(lastState => ({
        lastIndexToRender: Math.min(
          lastState.lastIndexToRender + this.props.batchSize,
          this.props.total - 1
        )
      }));
    }
  }

  getItems() {
    const items = [];
    for (let i = 0; i <= this.state.lastIndexToRender; i++) {
      items.push(this.props.renderItem(i));
    }

    return items;
  }

  render() {
    return <this.props.container ref={this.rootRef}>{this.getItems()}</this.props.container>;
  }
}
